<div>
  <p-overlayPanel #expTooltip appendTo="body" [showTransitionOptions]="'1000ms'" [hideTransitionOptions]="'500ms'">
    <dl>
      <dt> <i class="fa fa-archive"></i> {{ 'DossierDetail.dossier' | translate}} </dt>
      <dt>{{ 'DossierDetail.contract.object' | translate }}</dt>
      <dd>{{ dossier?.expedienteId }}</dd>
      <dt *ngIf="dossier?.situacion">{{ 'DossierDetail.situation.label' | translate }}</dt>
      <dd *ngIf="dossier?.situacion">
        {{ getSituationText() }}
      </dd>
      <dt *ngIf="dossier?.division?.phase">{{ 'DossierDetail.phase' | translate }}</dt>
      <dd *ngIf="dossier?.division?.phase">
        {{ dossier?.division?.phase?.description }}
      </dd>
      <dt *ngIf="dossier?.modoTramitacion"> {{ 'DossierDetail.process' | translate }} </dt>
      <dd *ngIf="dossier?.modoTramitacion">
        {{ dossier?.modoTramitacion?.description }}
      </dd>
      <dt *ngIf="dossier?.claseExpId"> {{ 'DossierDetail.class' | translate }} </dt>
      <dd *ngIf="dossier?.claseExpId">
        {{ dossier?.claseExpId?.description }}
      </dd>
      <dt *ngIf="dossier?.division?.procedure"> {{ 'DossierDetail.type.dossier' | translate }} </dt>
      <dd *ngIf="dossier?.division?.procedure">
        {{ dossier?.division?.procedure?.description }}
      </dd>
    </dl>
  </p-overlayPanel>
  <div>
    <i class="fa fa-lg fa-archive"  [ngClass]="getSituationClass()" aria-hidden="true" (mouseenter)="expTooltip.toggle($event)"
      (mouseleave)="expTooltip.toggle($event)"></i>&nbsp;
    <!-- si hay expedienteId se utiliza -->
    <a class="text-emphasis" (click)="openDossier(dossier)"
      *ngIf="dossier?.expedienteId && infoLink">{{ dossier?.expedienteId }}</a>
    <!-- si no hay expedienteId se utiliza la propuesta -->
    <a (click)="openDossier(dossier)" *ngIf="!dossier?.expedienteId && infoLink">{{ dossier?.identifier }}</a>
    <span *ngIf="dossier?.expedienteId && !infoLink">{{ dossier?.expedienteId
    }}</span>
    <!-- si no hay expedienteId se utiliza la propuesta -->
    <span *ngIf="!dossier?.expedienteId && !infoLink">{{ dossier?.identifier
    }}</span>
    <span *ngIf="infoTitulo" class="text-ellipsis"> {{ dossier?.titulo }}</span>
  </div>
  <div>
    <div *ngIf="
        showDivisionInfo &&
        dossier?.division?.parent &&
        dossier?.division?.parent?.identifier != '0'
      ">
      <span>
        <strong>{{ dossier?.division?.parent?.documentClass?.name }}:</strong>
        {{ dossier?.division?.parent?.name }}</span> > </div>
    <div *ngIf="
        showDivisionInfo &&
        dossier?.division &&
        dossier?.division?.identifier != '0'
      ">
      <span>
        <strong *ngIf="dossier?.division?.documentClass">{{ dossier?.division?.documentClass?.name }}:</strong>
        <span *ngIf="dossier?.division?.description">{{
          dossier?.division?.description
        }}</span>
      </span>
    </div>
  </div>
</div>
